import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import Stroller from "../../assets/Stroller.svg";
import {
  SummaryContainer,
  SummaryTitle,
  SummaryRow,
  SummaryLabel,
  SummaryValue,
  TotalLabel,
  PlaceOrderButton,
  NoteField,
  ButtonIcon,
} from "./OrderSummary.styles";

// Define the CartItemType interface
interface CartItemType {
  price: number;
  quantity: number;
  unit: number;
}

interface OrderSummaryProps {
  cartItems: CartItemType[];
  onPlaceOrder: () => Promise<void>;
  note: string;
  onNoteChange: (val: string) => void;
}

const OrderSummary = ({
  cartItems,
  onPlaceOrder,
  note,
  onNoteChange,
}: OrderSummaryProps) => {
  const totalAmount = cartItems?.reduce(
    (sum, item) => sum + item.price * item.quantity * item.unit,
    0
  );

  return (
    <SummaryContainer>
      <SummaryTitle variant="h5">Order Summary</SummaryTitle>

      <Box mt={2} display="flex" flexDirection="column" gap={1}>
        {/* Show the static summary items only once */}
        <SummaryRow mb={1}>
          <SummaryLabel>Sub Total</SummaryLabel>
          <SummaryValue>₹ {totalAmount}</SummaryValue>
        </SummaryRow>
        <SummaryRow mb={1}>
          <SummaryLabel>Shipping</SummaryLabel>
          <Typography>₹ 00</Typography>
        </SummaryRow>
        <SummaryRow fontWeight="bold">
          <TotalLabel variant="h6">Total:</TotalLabel>
          <SummaryValue variant="h6">₹ {totalAmount}</SummaryValue>
        </SummaryRow>
      </Box>

      {/* Add Note Section */}
      <Box>
        <SummaryLabel>Write a note</SummaryLabel>
        <NoteField
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          fullWidth
          multiline
          minRows={10}
          maxRows={10}
          variant="outlined"
          placeholder="Enter your note here..."
        />
      </Box>
      <PlaceOrderButton onClick={onPlaceOrder} variant="contained" fullWidth>
        <>
          <ButtonIcon src={Stroller} alt="Place order" />
          Place Order
        </>
      </PlaceOrderButton>
    </SummaryContainer>
  );
};

export default OrderSummary;
